import * as React from "react";
import { useContext } from "react";
import AuthContext from "src/context/AuthContext";

export const userHOC = (WrappedComponent: any) => {
	return (props: any) => {
		const { currentUser } = useContext(AuthContext);
		return (
			<WrappedComponent currentUser={currentUser} {...props} />
		);
	};
};
